(function (global) {
  const ISLAND_SWIPER_MOUSEWHEEL = Object.freeze({
    enabled: true,
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true,
    eventsTarget: 'container',
  });

  /**
   * Merge shared Swiper defaults (trackpad / mouse wheel) into section options.
   * @param {object} options
   * @returns {object}
   */
  function withIslandSwiperDefaults(options) {
    return Object.assign({}, options, {
      mousewheel: ISLAND_SWIPER_MOUSEWHEEL,
    });
  }

  global.ISLAND_SWIPER_MOUSEWHEEL = ISLAND_SWIPER_MOUSEWHEEL;
  global.withIslandSwiperDefaults = withIslandSwiperDefaults;
})(window);
